import { setupHandleError } from "error-logging!sofe";

export const handleError = setupHandleError("cp-client-auth");
